export function durationMinutes(entry) {
    if (typeof entry.msdyn_duration === "number" && Number.isFinite(entry.msdyn_duration)) {
        return Math.max(0, entry.msdyn_duration);
    }
    const minutes = (Date.parse(entry.msdyn_end) - Date.parse(entry.msdyn_start)) / 60000;
    if (!Number.isFinite(minutes))
        throw new Error("Time entry has an invalid start or end time.");
    return Math.max(0, Math.round(minutes));
}
export function entryHours(entry) {
    return durationMinutes(entry) / 60;
}
export function durationUnit(categoryId, categories) {
    return categories.find((c) => c.msdyn_transactioncategoryid === categoryId)?.rateUnit ?? "Hour";
}
export function roundDurationMinutes(minutes, unit) {
    if (!Number.isFinite(minutes) || minutes < 0) {
        throw new Error("Duration must be a finite, non-negative number.");
    }
    return unit === "Minute"
        ? Math.max(15, Math.round(minutes))
        : Math.max(60, Math.round(minutes / 15) * 15);
}
export function durationRule(unit) {
    return unit === "Minute"
        ? "Minimum 15 minutes; rounded to the nearest whole minute."
        : "Minimum 1 hour; rounded to the nearest 15 minutes.";
}
export function formatHours(hours) {
    return Number(hours.toFixed(2)).toString();
}
export function formatDuration(minutes, unit) {
    return unit === "Minute" ? `${minutes} min` : `${formatHours(minutes / 60)} h`;
}
export function formatEntryDuration(entry, categories) {
    return formatDuration(durationMinutes(entry), durationUnit(entry.msdyn_transactioncategoryid, categories));
}
